// @mui
import {
  Stack,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// hooks
import useResponsive from '../../hooks/useResponsive';
// utils
import Iconify from '../../components/Iconify';

export default function ExtendedNegoDeclineDialog({ isOpen, closeDialog, isSubmit, declineNego }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
          <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 20, height: 20, color: 'error.main' }} />
          <Typography variant="subtitle2" sx={{ color: "error.main" }}>
            잠깐, 꼭 확인해주세요
          </Typography>
        </Stack>
        <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
          매칭을 취소하고 싶나요?
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }} paragraph>
          현재 대기 인원이 많아 매칭 취소 후 다음 공고를 제안 받기까지 2주 이상 소요될 수 있습니다.
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }}>
          그래도 취소하시겠어요?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack
          justifyContent={"flex-end"}
          direction={smUp ? "row" : "column-reverse"}
          sx={{ width: 1 }}
          spacing={1}
        >
          <LoadingButton
            onClick={closeDialog}
            size="large"
            sx={{ px: 4 }}
            fullWidth={!smUp}
            loading={isSubmit}
          >
            더 기다리기
          </LoadingButton>
          <LoadingButton
            variant="contained"
            onClick={declineNego}
            size="large"
            sx={{ px: 4 }}
            fullWidth={!smUp}
            loading={isSubmit}
          >
            매칭 취소하기
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
};
